/**
 * blockKeys — `Esc` reverts the block the caret is in.
 *
 * The one intrinsic editor key the setup canvas keeps, and it is bound PER BLOCK rather than per
 * page: "revert what I was typing" is only meaningful if the handler knows which block it is on,
 * and every canvas that grows an editable block needs it to mean the same thing. It is standard
 * input semantics, not an advertised shortcut — nothing on the page announces it.
 */

import type { KeyboardEvent } from 'react';

export function blockKeyHandler(discard: () => void) {
    return (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            event.preventDefault();
            discard();
        }
    };
}
